import { updateUser } from "@/services/api";
import { useCurrentUser } from "@/services/hooks";
import { Box, Skeleton, TextField } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import debounce from "lodash/debounce";
import { useCallback, useEffect, useState } from "react";
import AlertSnackbar from "@/components/AlertSnackbar";
import { ForumOutlined, Instagram } from "@mui/icons-material";

export default function EditInstagram() {
  const { data: currentUser, isLoading } = useCurrentUser();
  const queryClient = useQueryClient();

  const [value, setValue] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);

  const metaKey = "instagram";

  // Update state when currentUser data is loaded
  useEffect(() => {
    if (currentUser) {
      setValue(currentUser.meta?.[metaKey] || "");
    }
  }, [currentUser]);

  const mutation = useMutation({
    mutationFn: () => updateUser(null, { [metaKey]: value }),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["current_user"] });
      setShowSnackbar(true);
    },
  });

  const debouncedSave = useCallback(
    debounce((newValue) => {
      mutation.mutate();
    }, 1000),
    []
  );

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    debouncedSave(newValue);
  };

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        height={56}
        width="100%"
        sx={{ borderRadius: "25px" }}
      />
    );
  }

  return (
    <Box>
      <AlertSnackbar
        showSnackbar={showSnackbar}
        setShowSnackbar={setShowSnackbar}
      />
      <TextField
        label={<Instagram />}
        placeholder="https://www.instagram.com/YOUR_USERNAME"
        value={value}
        fullWidth
        onChange={handleChange}
        disabled={mutation.isPending}
      />
    </Box>
  );
}
